import React from "react";
import ChallanGeneratedGraph from "./Common/ChallanGeneratedGraph";
import "./style.css";
import ChallaRequestReceived from "./Common/ChallanRequestReceived";
import FuelStatusGraph from "./Common/FuelStatusGraph";
import FuelConsumptionReport from "./Common/FuelConsumptionReport";
import WorkshopReport from "./Common/WorkshopReport";
import DutyReports from "./Common/DutyReports";
import GoodsRequested from "./Common/GoodsRequested";
import InvoiceGeneratedGraph from "./Common/InvoiceGeneratedGraph";
import OBTS from "./Common/OBTS";
import ChartDuty from "./Gangtok/ChartDuty";

function GangtokDashboard({ depoId }) {
  // console.log("depoId", depoId);
  return (
    <>
      <div className="row m-0">
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "360px" }}>
            <OBTS depo="20" />
          </div>
        </div>
        <div className="col col-12 col-md-12  col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "360px" }}>
            <InvoiceGeneratedGraph depo="20" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelStatusGraph />
          </div>
        </div>

        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <WorkshopReport depo="20" />
          </div>
        </div>

        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <ChartDuty />
          </div>
        </div>

        {/* Removed Reports */}
        {/* <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "360px" }}>
            <ChallanGeneratedGraph depo="20" />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <GoodsRequested depo="20" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <ChallaRequestReceived depo="1" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelConsumptionReport />
          </div>
        </div> 
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <DutyReports depo="1" />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default GangtokDashboard;
